module.exports = __webpack_public_path__ + "img/13.a2572007.jpg";